import React from "react";
import Grid from "../../components/Grid/Grid";
import data from "../../data/projects.json";
import "./MusicVideos.css";

function MusicVideos() {
  const items = data.filter((p) => p.category === "MusicVideos");
  return (
    <section className="MusicVideos">
      <h1 className="MusicVideos__title">Music Videos</h1>
      <Grid items={items} className="Grid--singleCol Grid--wide" />
    </section>
  );
}

export default MusicVideos;
